module.exports = __webpack_public_path__ + "img/RABaseBG-Soft.8753b1fd.png";